import { Box, Stack } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useReceiptList } from 'hooks';
import { ReceiptRoot, sharedStyles } from 'lib';
import { HelixLoader } from 'components';
import { getColumns, getConsentContractColumns } from './receipt-list-helpers';
import React, { useEffect } from 'react';

interface ReceiptListProps {
    selectedChain: string;
    selectedReceiptId?: string;
    setSelectedReceipt: Function;
    contractType?: string;
    receiptType: 'admin' | 'user';
}

export const ReceiptList = ({
    selectedChain,
    selectedReceiptId,
    setSelectedReceipt,
    contractType,
    receiptType,
}: ReceiptListProps): React.JSX.Element => {
    const { data, isLoading, isFetched } = useReceiptList({
        chain: selectedChain,
        contractType,
        receiptType,
    });
    const handleReceiptClick = (receipt: ReceiptRoot): void => {
        setSelectedReceipt(receipt);
    };

    useEffect(() => {
        if (isFetched && data && selectedReceiptId) {
            const receipts: ReceiptRoot[] = data.data ?? [];
            const receiptFound: ReceiptRoot | undefined = receipts.find(
                (receipt) => receipt?.header?.id === selectedReceiptId
            );

            if (receiptFound) {
                setSelectedReceipt(receiptFound);
            }
        }
    }, [selectedReceiptId, data, isFetched]); // eslint-disable-line react-hooks/exhaustive-deps

    if (isLoading) {
        return <HelixLoader />;
    }
    return (
        <Box sx={sharedStyles.dataGridWrapper}>
            {data?.data ? (
                <Stack>
                    <DataGrid
                        autoHeight
                        style={sharedStyles.dataGrid}
                        rows={data.data}
                        columns={
                            contractType === 'smartcontracts'
                                ? getColumns()
                                : getConsentContractColumns()
                        }
                        getRowId={(row): string => row.header.id}
                        rowHeight={38}
                        disableRowSelectionOnClick
                        onRowClick={(dataGridProMap: any): void => {
                            handleReceiptClick(dataGridProMap?.row);
                        }}
                        initialState={{
                            pagination: { paginationModel: { pageSize: 10 } },
                        }}
                        pageSizeOptions={[5, 10, 20]}
                        pagination
                        sx={sharedStyles.removeTableFocus}
                    />
                </Stack>
            ) : null}
        </Box>
    );
};
